function getTimeOfDayGreetingKey() {
  const hour = new Date().getHours()

  if (hour < 12) {
    return 'Greta.GreetingMorningKey'
  }

  if (hour < 18) {
    return 'Greta.GreetingAfternoonKey'
  }

  return 'Greta.GreetingEveningKey'
}

export function getGretaGreetingHeading(t, displayName) {
  const greeting = t(getTimeOfDayGreetingKey())
  const firstName = displayName?.trim().split(/\s+/)[0]

  return firstName ? `${greeting}, ${firstName}` : greeting
}
